import React from "react";
import RotatedMarker from "../RotatedMarker";
import { Tooltip } from "react-leaflet";

export type MarkerData = {
    imei: string;
    lat: number;
    lng: number;
    yaw: number;
    isOnline: boolean;
}

interface ConsoleMapMarkerProps {
    marker: MarkerData;
    icon: L.Icon;
    /** Подпись у маркера — имя устройства, IMEI как запасной вариант. */
    label: string;
    /** Выбран в списке: маркер поднимается над остальными и подсвечивается. */
    isSelected: boolean;
    onClick: (marker: MarkerData) => void;
    isOnline: boolean;
}

function ConsoleMapMarker({ marker, icon, label, isSelected, onClick }: ConsoleMapMarkerProps) {
    return (
        <RotatedMarker
            key={marker.imei}
            position={[marker.lat, marker.lng]}
            icon={icon}
            rotationAngle={-marker.yaw}
            zIndexOffset={isSelected ? 1000 : 0}
            eventHandlers={{
                click: () => onClick(marker)
            }}
        >
            <Tooltip
                permanent
                direction="bottom"
                offset={[15, 20]}
                opacity={1}
                className={'console-map-label' + (isSelected ? ' console-map-label-active' : '')}
            >
                {label}
            </Tooltip>
        </RotatedMarker>
    );
}

export default React.memo(ConsoleMapMarker, (prevProps, nextProps) => {
    return (
        prevProps.marker.lat === nextProps.marker.lat &&
        prevProps.marker.lng === nextProps.marker.lng &&
        prevProps.marker.yaw === nextProps.marker.yaw &&
        prevProps.isOnline === nextProps.isOnline &&
        prevProps.isSelected === nextProps.isSelected &&
        prevProps.label === nextProps.label &&
        prevProps.icon === nextProps.icon &&
        prevProps.onClick === nextProps.onClick
    );
});
